export const permissionTypes = [
    "Usuario",
    "Atendente",
    "Coordenador",
    "Coordenador de Atendimento",
    "Gerente",
    "Gerente de Atendimento",
    "Administrador",
    "Administrador de Atendimento",
    "Desenvolvedor",
];

export function getUserHighestPermission(profiles: string[]): { name: string; level: number } {
    const permissions = permissionTypes.map(
        (permission, index) => ({ name: permission, level: index })
    );

    if (!profiles || profiles.length === 0) {
        return permissions[0];
    }

    const userPermissionLevels = profiles.map(
        perfil => permissions.find((p) => p.name === perfil)
    ).filter(Boolean);

    const highestPermission = userPermissionLevels.reduce((highest, current) => {
        return current.level > highest.level ? current : highest;
    }, userPermissionLevels[0]);

    if (!highestPermission) {
        return permissions[0];
    }

    return highestPermission;
}
